export default __webpack_public_path__ + "static/illustration-content-title.url-320be2430cb76edd34330da0e3aba29d.svg";